import { render, staticRenderFns } from "./Tax.vue?vue&type=template&id=f09b4b84"
import script from "./Tax.vue?vue&type=script&lang=js"
export * from "./Tax.vue?vue&type=script&lang=js"
import style0 from "./Tax.vue?vue&type=style&index=0&id=f09b4b84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports